import { render, staticRenderFns } from "./Bundles.vue?vue&type=template&id=74ca3ff3&scoped=true"
import script from "./Bundles.vue?vue&type=script&lang=js"
export * from "./Bundles.vue?vue&type=script&lang=js"
import style0 from "./Bundles.vue?vue&type=style&index=0&id=74ca3ff3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca3ff3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ca3ff3')) {
      api.createRecord('74ca3ff3', component.options)
    } else {
      api.reload('74ca3ff3', component.options)
    }
    module.hot.accept("./Bundles.vue?vue&type=template&id=74ca3ff3&scoped=true", function () {
      api.rerender('74ca3ff3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/bundles/Bundles.vue"
export default component.exports